module.exports = __webpack_public_path__ + "static/wrkat-extraimg1@2x-min-870f9f04fdb745f0a1e539b08ef85b85.png";